import React, { useEffect, useRef } from 'react';
import { Navigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { selectDefaultModulePath } from '../../../redux/slices/layout';
import { useAppSelector } from '../../../redux/hooks';

/* Navigates to the default module */
function DefaultRedirectRoute() {
  const defaultModulePath = useAppSelector(selectDefaultModulePath);
  const { t } = useTranslation();
  const openedRef = useRef(false);

  useEffect(() => {
    if (defaultModulePath?.target === '_blank' && !openedRef.current) {
      openedRef.current = true;
      window.open(defaultModulePath.to, defaultModulePath.target, 'noopener,noreferrer');
    }
  }, [defaultModulePath]);

  if (defaultModulePath?.target === '_blank') {
    return (
      <p className="text-center">
        {t('opened-in-new-tab')}
        <br />
        <a href={defaultModulePath.to} target="_blank" rel="noopener noreferrer">
          {t('click-here-if-not-redirected')}
        </a>
      </p>
    );
  }

  return defaultModulePath ? <Navigate to={defaultModulePath.to} /> : null;
}

export default DefaultRedirectRoute;
